import { createApp } from 'vue/dist/vue.esm-bundler';
import PressReleases from './PressReleases.vue';


const mountEl = document.querySelector('[data-app-press-releases-list]');

if ( mountEl )
{
    createApp(PressReleases, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}